import { Formik } from "formik"
import * as yup from "yup"
import { formatPrice } from "../../utils/utility"
import Button from "../common/button"
import TextInput from "../common/input"
import styles from "./loan-calculator-form.module.scss"
import RangeSlider from "../common/range-slider"

const LoanCalculatorForm = ({ onCalculate, isMobile }) => {
  return (
    <Formik
      initialValues={{
        propertyPrice: "",
        years: "5",
        downPayment: "10",
        interestRate: "12.91",
      }}
      validationSchema={yup.object().shape({
        propertyPrice: yup.string().required("Please enter price"),
      })}
      onSubmit={(values) => {
        onCalculate(values)
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, resetForm }) => (
        <form className={`${styles.loanCalcForm}`} onSubmit={handleSubmit}>
          <div className={`${!isMobile ? styles.loanCalcFormInner : ""} ${styles.pRelative} u-mb8`.trim()}>
            <div
              className={`${styles.fieldWrap} ${styles.loanFieldHeight} ${styles.loanFieldPdg} ${styles.pRelative} u-mb16`}
            >
              <span className={`${styles.animateLabel} ${styles.pAbsolute} ${styles.focus}`}>Property Price</span>
              <div className={styles.priceGroup}>
                <TextInput
                  className={`${styles.selectedValue} ${styles.input}`}
                  type="number"
                  name="p-price"
                  id="propertyPrice"
                  onChange={handleChange("propertyPrice")}
                  onBlur={handleBlur("propertyPrice")}
                  value={values.propertyPrice}
                  placeholder="Property Price"
                />
                <span className={`${styles.error} flex`}>
                  {errors.propertyPrice && touched.propertyPrice && errors.propertyPrice}
                </span>
                {values.propertyPrice && (
                  <span className={`${styles.staticPrice} ${styles.pAbsolute}`} id="t-price">
                    {`PKR ${formatPrice(values.propertyPrice)}`}
                  </span>
                )}
              </div>
            </div>

            <div
              className={`${styles.fieldWrap} ${styles.interestWrap} ${styles.loanFieldPdg} ${styles.pRelative} u-mb16`}
            >
              <RangeSlider
                formattedValue={values.years || ""}
                label={"Years"}
                control="single"
                sliderDefaultValue="5"
                min={1}
                step={1}
                max={30}
                value={values.years}
                onChange={(val) => {
                  handleChange("years")({ target: { value: val } })
                }}
              />
            </div>

            <div
              className={`${styles.fieldWrap} ${styles.interestWrap} ${styles.loanFieldPdg} ${styles.pRelative} u-mb16`}
            >
              <RangeSlider
                formattedValue={values.downPayment ? `${values.downPayment}%` : ""}
                label={"Down Payment"}
                control="single"
                sliderDefaultValue="10"
                min={5}
                step={1}
                max={60}
                value={values.downPayment}
                onChange={(val) => {
                  handleChange("downPayment")({ target: { value: val } })
                }}
              />
            </div>

            <div
              className={`${styles.fieldWrap} ${styles.interestWrap} ${styles.loanFieldPdg} ${styles.pRelative} u-mb16`}
            >
              <RangeSlider
                formattedValue={values.interestRate ? `${values.interestRate}%` : ""}
                label={"Interest Rate"}
                control="single"
                sliderDefaultValue="5"
                min={5}
                step={0.1}
                max={30}
                value={values.interestRate}
                onChange={(val) => {
                  handleChange("interestRate")({ target: { value: val } })
                }}
              />
            </div>
          </div>
          <div className="flex u-spbwx8">
            <Button onClick={resetForm} variant={isMobile ? "secondaryGhostBtn" : "secondaryBtn"}>
              Reset
            </Button>
            <Button className="flex-grow" variant={isMobile ? "secondaryBtn" : "primaryBtn"} size="md" onClick={handleSubmit}>
              Calculate
            </Button>
          </div>
        </form>
      )}
    </Formik>
  )
}

export default LoanCalculatorForm
